module.exports = function() {
  return new Worker(__webpack_public_path__ + "dcf1dc331d7c78586ad5.worker.js");
};